import { LandingPage } from '../LandingPage';
import { doctorsConfig } from './config';

export default function DoctorsLandingPage() {
  return <LandingPage config={doctorsConfig} />;
}
